import React from 'react';

import { useEditRecipientTaxIdentifiersFormContext } from './context';
import { EditTaxIdentifiersTable } from './edit-tax-identifiers-table';
import { EditRecipientTaxIdentifiersFormRow } from './edit-tax-identifiers-form-row';
import { EditTaxIdentifiersAddButton } from './edit-tax-identifiers-add-button';

const MAX_TAX_IDS = 3;

export const EditRecipientTaxIdentifiersForm = () => {
  const { addNewTaxId, taxIdentifiers } = useEditRecipientTaxIdentifiersFormContext();
  const showAddButton = (taxIdentifiers || [])?.length < MAX_TAX_IDS;

  return (
    <>
      <EditTaxIdentifiersTable>
        {!taxIdentifiers?.length ? (
          <EditRecipientTaxIdentifiersFormRow />
        ) : (
          <>
            {taxIdentifiers.map((taxId, index) => (
              <EditRecipientTaxIdentifiersFormRow
                key={taxId.type || index}
                id={index}
                showClearButton={taxIdentifiers.length === 1}
                taxIdentifier={taxId}
              />
            ))}
          </>
        )}
      </EditTaxIdentifiersTable>

      {showAddButton && <EditTaxIdentifiersAddButton onClick={addNewTaxId} />}
    </>
  );
};
